module.exports = __webpack_public_path__ + "static/media/valueAddedServicesNewKtm.ef8ce2a9.svg";